import React from 'react';
import styles from './styles.module.css';
import { memo } from 'react';
import mark from '../../assets/imgs/img_sample_note.png';

const SampleMark = memo(() => {
    return (
        <>
            <div className={styles.sampleMarkContainer}>
                <img className={styles.markImg} src={mark} alt="Sample-Mark" />
            </div>
        </>
    );
});

export default SampleMark;
